import { ContentfulService } from '@shared/services/contentful/contentful.service';
import { TranslateLoaderService } from '@shared/services/translate-loader/translate-loader.service';

export function TransLoaderFactory(content: ContentfulService) {
  return new TranslateLoaderService(content);
}
